<template>
  <div>
    <v-autocomplete
      v-model="selecionados"
      :items="filiaisFiltradas"
      item-text="descricao"
      item-value="filial"
      :multiple="!drpReverso && selecaoMultipla"
      hide-selected
      outlined
      clearable
      height="10"
      return-object
      hide-details
      :placeholder="placeholder"
      no-data-text="Todas Filiais estão selecionadas"
      :error="selecionadosForceArray.length === 0"
    >
      <template v-slot:selection>
        <!-- NADA -->
      </template>

      <template v-slot:prepend-item v-if="!drpReverso && selecaoMultipla">
        <v-list-item class="sys-item-prepended-list px-3 py-2" @click="selecionarTodos()">
          <template v-if="selecionadosForceArray.length === filiaisFiltradas.length">
            <v-icon color="primary">mdi-checkbox-marked</v-icon>
            <span class="subtitle-1 ml-3">Desmarcar todas</span>
          </template>
          <template v-else>
            <v-icon v-if="!selecionadosForceArray.length">mdi-checkbox-blank-outline</v-icon>
            <v-icon v-else color="primary">mdi-minus-box</v-icon>
            <span class="subtitle-1 ml-3">Selecionar todas</span>
          </template>
        </v-list-item>

        <v-divider />
      </template>

      <template v-slot:prepend-inner v-if="selecionadosForceArray.length">
        <v-chip class="mt-n1 txt-row">
          {{ prependInner }}
        </v-chip>
      </template>
    </v-autocomplete>

    <div id="itens-selecionados">
      <v-list dense>
        <v-subheader>
          {{ tituloLista }}
          <span v-show="!drpReverso" class="pl-1 blue--text cursor-pointer" @click="irParaTelaMapaSeparacao">
            configurar
            <v-icon color="primary" :size="11">$Link</v-icon>
          </span>
        </v-subheader>

        <template v-for="(item, index) in selecionadosForceArray">
          <v-list-item :key="index">
            <v-list-item-action title="Desmacar" class="ml-n3">
              <v-btn icon color="primary" @click="removerItem(item)">
                <v-icon>mdi-checkbox-marked</v-icon>
              </v-btn>
            </v-list-item-action>

            <v-list-item-title v-text="item.descricao"></v-list-item-title >

            <v-btn icon @click="removerItem(item)" title="Desmacar">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-list-item>

          <v-divider
            v-if="index < selecionadosForceArray.length - 1"
            :key="`${index}_`"
          ></v-divider>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
export default {
  name: "autoCompleteFilial",
  props: {
    items: {
      type: Array,
      required: true
    },
    autoSelecionarTodos: {
      type: Boolean,
      required: false
    },
    drpReverso: {
      type: Boolean,
      required: false
    },
    selecaoMultipla: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    selecionados: []
  }),
  computed: {
    qtdeSelecionados () {
      if (this.selecionadosForceArray.length === this.filiaisFiltradas.length) {
        return 'Todas'
      }

      return this.selecionadosForceArray.length
    },
    filiaisFiltradas () {
      if (this.drpReverso && 1 === 2) { // 1 === 2 -> localStorage.config_cfgsystem_ativa === true;
        return this.items.filter(item => ['S', 's'].includes(item.filial_cd))
      }

      return this.items
    },
    tituloLista () {
      let str = this.selecionadosForceArray.length > 0
        ? `Filia${this.drpReverso ? 'l' : 'is'} selecionada${this.drpReverso ? '' : 's'}`
        : `Selecione uma ${this.drpReverso ? 'Filial' : 'ou mais Filiais'}`

      str = str.concat(' - ', this.drpReverso ? 'Destino' : 'Origem',  ' do estoque')

      return str
    },
    selecionadosForceArray () {
      let values = this.selecionados;

      if (!values || values == '') {
        values = []
      }

      if (!Array.isArray(values)) {
        values = [values]
      }

      return values
    },
    prependInner () {
      if (this.drpReverso) {
        return `Filial CD de destino selecionada`
      }

      return `${this.qtdeSelecionados} Filia${this.selecionadosForceArray.length > 1 ? 'is' : 'l'} Origem selecionada${this.selecionadosForceArray.length > 1 ? 's' : ''}`
    },
    placeholder () {
      if (this.selecionadosForceArray.length > 0) {
        return ''
      }

      return this.drpReverso ? 'Lista de Filiais do tipo CD' : 'Lista de Filiais Origens'
    }
  },
  mounted() {
    this.selecionados = []

    if (!this.drpReverso && this.selecaoMultipla) {
      this.selecionarTodos(true)
    }
  },
  watch: {
    selecionadosForceArray (values) {
      this.$emit('change', this.Helpers.arrayColumn(values, 'filial'))
    },
    autoSelecionarTodos () {
      if (this.autoSelecionarTodos) {
        if (this.drpReverso || !this.selecaoMultipla) {
          this.selecionados = []
        } else {
          this.selecionados = []
          this.selecionarTodos()
        }
      }
    }
  },
  methods: {
    removerItem (item) {
      if (this.drpReverso) {
        this.selecionados = ''
      }else {
        this.selecionados = this.selecaoMultipla
          ? this.selecionados.filter(filial => filial.filial != item.filial)
          : '';
      }
    },
    selecionarTodos () {
      if (this.selecionadosForceArray.length > 0 && this.selecionadosForceArray.length === this.filiaisFiltradas.length) {
        this.selecionados = []
      } else {
        this.selecionados = this.filiaisFiltradas
      }
    },
    irParaTelaMapaSeparacao() {
      this.$router.push({ name: "drpMapaDeSeparacao" });
    }
  }
}
</script>

<style scoped>
.txt-row {
  white-space: nowrap
}
#itens-selecionados {
  border-left: 1px solid rgba(0,0,0,.1);
  border-right: 1px solid rgba(0,0,0,.1);
  height: calc(100vh - 135px);
  overflow-y: auto;
}
</style>
